/*
  Icon.tsx is deprecated! Use SvgIcon.tsx instead.
*/
import { PureComponent, ReactNode } from 'react'
import * as styles from 'styles/atoms/Icon.css'
import * as cn from 'classnames'

export type LoadingIconKind =
  | 'spinner'
  | 'spinner-light'
  | 'spinner-success'
  | 'spinner-error'
  | 'spinner-warning'

export type OperationResultKind =
  | 'warning'
  | 'fail'
  | 'success'
  | 'danger'

export type RestIconKind =
  | 'chevron-secondary'
  | 'chevron-notifications'
  | 'ellipsis'
  | 'question'
  | 'secure'
  | 'close'

export type IconKind =
  | LoadingIconKind
  | OperationResultKind
  | RestIconKind

const LOADING_KINDS: LoadingIconKind[] = [
  'spinner', 'spinner-light',
  'spinner-success', 'spinner-error', 'spinner-warning',
]

const OPERATION_RESULT_KIND: OperationResultKind[] = [
  'warning', 'fail', 'success', 'danger',
]

const REST_KINDS: RestIconKind[] = [
  'chevron-secondary',
  'chevron-notifications',
  'ellipsis',
  'question',
  'secure',
  'close',
]

const ICON_KINDS: IconKind[] = [
  ...LOADING_KINDS,
  ...OPERATION_RESULT_KIND,
  ...REST_KINDS,
]

const ICON_KINDS_SET: Set<IconKind> = new Set(ICON_KINDS)

type IconProps = {
  kind: IconKind
}

const DEFAULT_ICON_VIEWBOX = '0 0 48 48'

const ICON_VIEWBOX: Partial<Record<IconKind, string>> = {
  secure: '0 0 11 16',
  close: '0 0 20 20',
}

const ROTATING_SPINNERS: LoadingIconKind[] = ['spinner', 'spinner-light']
const ANIMATING_SPINNERS: LoadingIconKind[] = ['spinner-success', 'spinner-error', 'spinner-warning']

const SVG_SCHEMA = 'http://www.w3.org/2000/svg'

const EMBEDDED_ICONS: IconKind[] = [
  'secure', 'close',
]

class Icon extends PureComponent<IconProps> {

  render () {
    const { kind } = this.props

    if (!ICON_KINDS_SET.has(kind)) {
      return null
    }

    let imageUrl: string | undefined
    let innerSvg: ReactNode | null = null
    const additionalClasses = this.getAdditionalClasses(kind)

    if (EMBEDDED_ICONS.includes(kind)) {
      innerSvg = (
        <svg className={ styles.innerSvg } xmlns={ SVG_SCHEMA } viewBox={ ICON_VIEWBOX[kind] || DEFAULT_ICON_VIEWBOX }>
          <use xlinkHref={ `#${ kind }` } />
        </svg>
      )
    } else {
      imageUrl = `url(/images/icons/${ kind }.svg)`
    }

    return (
      <span className={ cn(styles.icon, ...additionalClasses) } style={{ backgroundImage: imageUrl }}>
        { innerSvg }
      </span>
    )
  }

  private getAdditionalClasses = (kind: IconKind): string[] => {
    const stringKind = kind as LoadingIconKind
    if (ROTATING_SPINNERS.includes(stringKind)) {
      return [styles.rotating]
    }

    if (ANIMATING_SPINNERS.includes(stringKind)) {
      return [styles.playable]
    }

    return []
  }
}

export default Icon
